import type {SVGProps} from 'react'

const SvgElectric = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={24}
    height={24}
    fill={'none'}
    viewBox={'0 0 24 24'}
    {...props}
  >
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M5.125 8.5c0-.897.728-1.625 1.625-1.625h10.5c.898 0 1.625.728 1.625 1.625v4.389c0 3.733-3.091 6.736-6.875 6.736s-6.875-3.003-6.875-6.736zm1.625-.375a.375.375 0 0 0-.375.375v4.389c0 3.017 2.505 5.486 5.625 5.486s5.625-2.47 5.625-5.486V8.5a.375.375 0 0 0-.375-.375z'}
      clipRule={'evenodd'}
    />
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M15.625 3.5v4h-1.25v-4zM9.625 3.5v4h-1.25v-4zM11.42 10.268l1.16.464-.657 1.643h2l-1.343 3.357-1.16-.464.657-1.643h-2z'}
      clipRule={'evenodd'}
    />
  </svg>
)
export default SvgElectric
